import { render, staticRenderFns } from "./transaction-history-details.vue?vue&type=template&id=6e7bfe68&"
import script from "./transaction-history-details.vue?vue&type=script&lang=js&"
export * from "./transaction-history-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports